<script setup>
import { computed, watch } from 'vue'
import { useStore } from 'vuex'

import DikeProfilesCard from '@/components/dikeProfile/DikeProfilesCard.vue'
import ExpandBtn from '@/components/common/ExpandBtn.vue'

const store = useStore()

const props = defineProps({
  drawerWidth: {
    type: String,
    required: true
  },
  expand: {
    type: Boolean,
    default: false
  }
})

const showElevationProfiles = computed(() => store.state.dikeProfiles.showElevationProfiles)
const currentDikeSection = computed(() => store.state.dikeSection.currentItem)

const expandState = computed({
  get: () => props.expand,
  set: (value) => emit('toggleExpand', value)
})

const fetchDikeProfilesElevation = async (id) =>
  store.dispatch('dikeProfiles/fetchDikeProfilesElevation', id)

watch(currentDikeSection, async (value) => {
  value ? await fetchDikeProfilesElevation(value.id) : null
})

const emit = defineEmits(['toggleExpand'])
</script>

<template>
  <v-navigation-drawer
    v-if="showElevationProfiles"
    location="right"
    :style="{ width: drawerWidth, transition: 'none' }"
  >
    <ExpandBtn v-model="expandState" />
    <DikeProfilesCard class="fill-height" />
  </v-navigation-drawer>
</template>
